import SourcesOfIncome from './sourcesofincome'

export default SourcesOfIncome
